import React from 'react';
import { DateFilterContainer } from '../../shared';
import { TableStatisticsTable } from './TableStatisticsTable';

const TableStatistics = () => (
    <DateFilterContainer>
        <TableStatisticsTable />
    </DateFilterContainer>
);

export default TableStatistics;